import { render, staticRenderFns } from "./CreateItemModal.vue?vue&type=template&id=94925156&"
import script from "./CreateItemModal.vue?vue&type=script&lang=ts&"
export * from "./CreateItemModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports